import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "order-tabs status-tabs"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('批次状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "data-permission": "transport_order_batch_manage_label_manage_status",
      "id": "transport_order_batch_manage_label_manage_status",
      "data-sign": "outbound_order_list_status",
      "animated": false
    },
    on: {
      "change": _vm.handleStatusChange
    },
    model: {
      value: _vm.searchData.box_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "box_status", $$v);
      },
      expression: "searchData.box_status"
    }
  }, _vm._l(_vm.statusList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": item.text
      }
    });
  }), 1)], 1), _c('my-enter-search', {
    attrs: {
      "data-sign": "transport_order_list_form"
    },
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "transport_order_batch_manage_label_manage_code_type",
      "id": "transport_order_batch_manage_label_manage_code_type"
    },
    model: {
      value: _vm.searchData.code_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_type", $$v);
      },
      expression: "searchData.code_type"
    }
  }, _vm._l(_vm.searchCodeTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "maxLength": 100,
      "data-permission": "transport_order_batch_manage_label_manage_code_value",
      "id": "transport_order_batch_manage_label_manage_code_value",
      "placeholder": _vm.t('双击可批量查询'),
      "data-sign": "transport_order_label_manage_list_dblclick"
    },
    on: {
      "dblclick": _vm.handleDblClick,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleSearch($event);
      }
    },
    model: {
      value: _vm.docValue,
      callback: function ($$v) {
        _vm.docValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docValue"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": 1,
      "data-permission": "transport_order_batch_manage_label_manage_date_type",
      "id": "transport_order_batch_manage_label_manage_date_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "data-permission": "transport_order_label_manage_search_creat",
      "id": "transport_order_label_manage_search_creat",
      "value": 1
    }
  }, [_vm._v(_vm._s(_vm.t('预报时间')))])], 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "transport_order_batch_manage_label_manage_range_picker",
      "id": "transport_order_batch_manage_label_manage_range_picker",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "bottom",
      "margin-top": "10px"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "data-permission": "transport_order_batch_manage_label_manage_search",
      "id": "transport_order_batch_manage_label_manage_search",
      "data-sign": "transport_order_label_manage_list_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "data-permission": "transport_order_batch_manage_label_manage_reset",
      "id": "transport_order_batch_manage_label_manage_reset",
      "data-sign": "transport_order_label_manage_list_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "listTool mt-10"
  }, [_c('div', {
    staticClass: "fl"
  }, [_vm._v(" " + _vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', '：')) + " " + _vm._s(_vm.selectedList.length) + " "), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'transport_order_label_manage_export',
      expression: "'transport_order_label_manage_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "transport_order_batch_manage_label_manage_export_all",
      "id": "transport_order_batch_manage_label_manage_export_all",
      "data-sign": "transport_order_label_manage_list_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "transport_order_batch_manage_label_manage_export_selected",
      "id": "transport_order_batch_manage_label_manage_export_selected",
      "data-sign": "transport_order_label_manage_list_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "data-permission": "transport_order_batch_manage_label_manage_export",
      "id": "transport_order_batch_manage_label_manage_export",
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext",
    attrs: {
      "bordered": "",
      "is-filter-box": "",
      "fixed-header": "",
      "useMouseTool": "",
      "columns": _vm.columns,
      "name": "transportOrderLabelList",
      "data-source": _vm.listData,
      "row-key": "shipping_mark_number",
      "data-sign": "transport_order_label_manage_list_table",
      "row-selection": _vm.rowSelection
    },
    scopedSlots: _vm._u([{
      key: "shipping_mark_number",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('a', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.shipping_mark_number,
            expression: "record.shipping_mark_number"
          }],
          attrs: {
            "href": "javascript:"
          },
          on: {
            "click": function ($event) {
              return _vm.handleShowDetail(record);
            }
          }
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record.shipping_mark_number)))])]);
      }
    }, {
      key: "forcast_warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.forcast_warehouse_code ? _c('span', [_vm._v(_vm._s(record.forcast_warehouse_code))]) : _vm._e(), record.forcast_warehouse_name ? _c('span', [_vm._v("[" + _vm._s(record.forcast_warehouse_name) + "]")]) : _vm._e()]);
      }
    }, {
      key: "signin_warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.signin_warehouse_code ? _c('span', [_vm._v(_vm._s(record.signin_warehouse_code))]) : _vm._e(), record.signin_warehouse_name ? _c('span', [_vm._v("[" + _vm._s(record.signin_warehouse_name) + "]")]) : _vm._e()]);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.forecast_date ? _c('p', {
          staticClass: "time-container"
        }, [_c('span', {
          staticClass: "time-container-label"
        }, [_vm._v(_vm._s(_vm.t('预报')) + _vm._s(_vm.t('common', '：')))]), _c('span', [_vm._v(_vm._s(record.forecast_date))])]) : _vm._e(), record.sign_in_date ? _c('p', {
          staticClass: "time-container"
        }, [_c('span', {
          staticClass: "time-container-label"
        }, [_vm._v(_vm._s(_vm.t('签收')) + _vm._s(_vm.t('common', '：')))]), _c('span', [_vm._v(_vm._s(record.sign_in_date))])]) : _vm._e()]);
      }
    }])
  })], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "total": _vm.total,
      "isFixed": "",
      "name": "transportOrderLabelList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    },
    model: {
      value: _vm.searchData.page_index,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "page_index", $$v);
      },
      expression: "searchData.page_index"
    }
  })], 1)], 1), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    attrs: {
      "max-number": _vm.$config.orderCodeBatchSearchMax
    },
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };